module.exports = "<app-high-stock-chart (chartReady)=\"onHighStockLoaded($event)\" [unit]=\"unit\" [variable]=\"variable\" [selectedPeriod]=\"selectedPeriod\" [selectedBaseTemp]=\"selectedBaseTemp\" [selectedLatlng]=\"selectedLatlng\"></app-high-stock-chart>"


//////////////////
// WEBPACK FOOTER
// ./src/app/charts/charts.component.html
// module id = ./src/app/charts/charts.component.html
// module chunks = main